import React, { useEffect } from "react";
import { Modal, Form, Input, InputNumber, Select, Button } from "antd";

const { Option } = Select;

const ModalCreateOrEditHmo = ({ visible, onClose, onSubmit, hmo, loading }) => {
  const [form] = Form.useForm();

  useEffect(() => {
    if (visible) {
      if (hmo) {
        form.setFieldsValue({
          name: hmo.name,
          allowable_checks_per_week: hmo.allowable_checks_per_week || 3,
          status: hmo.status || "active",
        });
      } else {
        form.resetFields();
        form.setFieldsValue({
          allowable_checks_per_week: 3,
          status: "active",
        });
      }
    }
  }, [visible, hmo, form]);

  const handleFinish = async (values) => {
    await onSubmit(values);
  };

  return (
    <Modal
      title={hmo ? `Edit HMO: ${hmo.name}` : "Add Supported HMO"}
      visible={visible}
      onCancel={onClose}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          name="name"
          label="HMO Provider Name"
          rules={[{ required: true, message: "Please enter HMO provider name" }]}
        >
          <Input placeholder="e.g. Hygeia, Reliance, AXA Mansard" />
        </Form.Item>

        <Form.Item
          name="allowable_checks_per_week"
          label="Allowable Check-ins Per Week"
          rules={[{ required: true, message: "Please specify allowable check-ins per week" }]}
          extra="Number of allowed gym visits per week for members on this HMO without a paid plan"
        >
          <InputNumber min={1} max={14} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item
          name="status"
          label="Status"
          rules={[{ required: true }]}
        >
          <Select>
            <Option value="active">Active (Available for registration)</Option>
            <Option value="disabled">Disabled (Hidden from registration & check-ins blocked)</Option>
          </Select>
        </Form.Item>

        <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px", marginTop: "24px" }}>
          <Button onClick={onClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            {hmo ? "Save Changes" : "Create HMO"}
          </Button>
        </div>
      </Form>
    </Modal>
  );
};

export default ModalCreateOrEditHmo;
